import {
  Button,
  CloseButton,
  Combobox,
  Text,
  useCombobox,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';

import classes from '../harvest-proof-status-filter/harvest-proof-status-filter.module.css';

import {
  HARVEST_PROOF_REMINDER_FILTER_VALUES,
  HarvestProofReminderFilterValue,
} from '@harvest-proof/data-access';

interface HarvestProofReminderFilterProps {
  onChange: (value: HarvestProofReminderFilterValue) => void;
  onClear: () => void;
  value?: HarvestProofReminderFilterValue;
}

export function HarvestProofReminderFilter({
  onChange,
  onClear,
  value,
}: HarvestProofReminderFilterProps) {
  const { t } = useTranslation();
  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
  });

  const options = HARVEST_PROOF_REMINDER_FILTER_VALUES.map((filterValue) => (
    <Combobox.Option key={filterValue} value={filterValue}>
      {t(`harvest-proof.reminders.filter.${filterValue}`)}
    </Combobox.Option>
  ));

  return (
    <Combobox
      onOptionSubmit={(selected) => {
        onChange(selected as HarvestProofReminderFilterValue);
        combobox.closeDropdown();
      }}
      position="bottom-start"
      store={combobox}
    >
      <Combobox.Target>
        <Button
          className={classes.button}
          color="gray"
          fullWidth
          justify="space-between"
          onClick={() => combobox.toggleDropdown()}
          px="sm"
          rightSection={
            value ? (
              <CloseButton
                aria-label={t('common.clear')}
                onClick={(event) => {
                  event.stopPropagation();
                  onClear();
                }}
                onMouseDown={(event) => event.preventDefault()}
                size="sm"
              />
            ) : (
              <Combobox.Chevron />
            )
          }
          tt="initial"
          variant="light"
        >
          {value ? (
            <Text lineClamp={1} size="sm">
              {t(`harvest-proof.reminders.filter.${value}`)}
            </Text>
          ) : (
            <Text c="var(--mantine-color-placeholder)" size="sm">
              {t('harvest-proof.reminders.filter.placeholder')}
            </Text>
          )}
        </Button>
      </Combobox.Target>
      <Combobox.Dropdown>
        <Combobox.Options>{options}</Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  );
}
